import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ITEMS_PER_PAGE_OPTIONS} from '@constants/pagination/pagination.constant';

@Component({
    selector: 'scitis-ngx-pagination',
    templateUrl: './ngx-pagination.component.html',
    styleUrls: ['./ngx-pagination.component.scss'],
    standalone: false
})
export class NgxPaginationComponent {

  @Input()
  public id: string = 'pagination' + Math.random().toString(36).substring(2);
  @Input()
  public nextLabel: string = '';
  @Input()
  public previousLabel: string = '';
  @Input()
  public itemsPerPage: number = ITEMS_PER_PAGE_OPTIONS[0];
  @Input()
  public itemsPerPageOptions: number[] = ITEMS_PER_PAGE_OPTIONS;
  @Input()
  public maxSize: number = 7;
  @Input()
  public mainClass: string = '';
  @Input()
  public paginationClass: string = '';
  @Input()
  public itemsPerPageClass: string = 'd-inline-block';

  @Output()
  public pageNumberChange = new EventEmitter<number>();
  @Output()
  public itemsPerPageChange = new EventEmitter<number>();


  public onLoadPageNumber($event: number): void {
    this.pageNumberChange.emit($event);
  }

  public onItemsPerPageOptionsChange(event): void {
    const {value} = event.target;
    if (+value) {
      this.itemsPerPageChange.emit(+value);
    }
  }
}
